import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

import { maskEpi, toMajorUnits } from '../../bluesage/bluesage.util';

import { CancelPreauthDialogActions } from './cancel-preauth-dialog.actions';
import { cancelPreauthDialogFeature } from './cancel-preauth-dialog.feature';

@Component({
    selector: 'app-cancel-preauth-dialog',
    standalone: true,
    imports: [ CommonModule, ButtonModule, DialogModule ],
    templateUrl: './cancel-preauth-dialog.component.html',
})
export class CancelPreauthDialogComponent {
    actions = CancelPreauthDialogActions;

    viewModel$ = this.store.select(createSelector({
        target: cancelPreauthDialogFeature.selectTarget,
        amount: createSelector(
            cancelPreauthDialogFeature.selectTarget,
            (target) => toMajorUnits(target?.amountMinor ?? 0),
        ),
        terminal: createSelector(
            cancelPreauthDialogFeature.selectTarget,
            (target) => maskEpi(target?.terminalEpi),
        ),
    }));

    constructor(public store: Store) {}
}
